var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 11.058h-2a.94.94 0 0 1-.713-.306A1.06 1.06 0 0 1 15 9.995q0-.451.287-.757A.94.94 0 0 1 16 8.932h2V6.807q0-.45.288-.757A.94.94 0 0 1 19 5.745a.94.94 0 0 1 .712.305q.288.305.288.758v2.124h2a.94.94 0 0 1 .712.306q.288.306.288.757t-.288.757a.94.94 0 0 1-.712.305h-2v2.125q0 .452-.288.758a.94.94 0 0 1-.712.305.94.94 0 0 1-.712-.305 1.06 1.06 0 0 1-.288-.758zM9 12.12q-1.65 0-2.825-1.248Q5 9.623 5 7.87q0-1.754 1.175-3.002T9 3.62t2.825 1.248T13 7.87q0 1.754-1.175 3.002T9 12.12m-8 6.375v-.85q0-.903.438-1.66.437-.757 1.162-1.156a14.3 14.3 0 0 1 3.15-1.235A13 13 0 0 1 9 13.182q1.65 0 3.25.412a14.3 14.3 0 0 1 3.15 1.235q.724.399 1.162 1.156t.438 1.66v.85q0 .877-.587 1.5-.588.625-1.413.625H3q-.824 0-1.412-.624A2.1 2.1 0 0 1 1 18.495m2 0h12v-.85a1.05 1.05 0 0 0-.5-.903q-1.35-.717-2.725-1.076a10.95 10.95 0 0 0-5.55 0q-1.375.36-2.725 1.076-.224.132-.362.372T3 17.645zm6-8.5q.825 0 1.412-.624Q11 8.746 11 7.87q0-.877-.588-1.5Q9.826 5.744 9 5.744t-1.412.624A2.1 2.1 0 0 0 7 7.87q0 .877.588 1.5.587.625 1.412.625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person_add.6acbcb27ec6ae4a4566278cec4757c57.svg";
export { ForwardRef as ReactComponent };